import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a207548")

_pushScopeId("data-v-2a207548")
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "logo mobile-logo logo_37games" }, null, -1)
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "term" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "copyright" }, [
  /*#__PURE__*/_createVNode("cite", null, "© 2023 37GAMES All Rights Reserved.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "center" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "right" }, null, -1)
_popScopeId()

import { ref } from 'vue';


export default _defineComponent({
  setup(__props) {

const termArr = ref([
  {
    name: '資金決済法に基づく表示',
    link: 'https://gpassport.37games.com/center/JpServicePrivacy/customize?keyWord=xddqzj',
  },
  {
    name: '特定商取引法に基づく表示',
    link: 'https://gpassport.37games.com/center/JpServicePrivacy/customize?keyWord=xddqquyin',
  },
  {
    name: '利用規約',
    link: 'https://gpassport.37games.com/center/JpServicePrivacy/service',
  },
  {
    name: 'プライバシーポリシー',
    link: 'https://gpassport.37games.com/center/JpServicePrivacy/privacy',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(termArr.value, (item, index) => {
          return (_openBlock(), _createBlock("a", {
            key: index,
            href: item.link,
            target: "_blank"
          }, _toDisplayString(_ctx.$t(item.name)), 9, ["href"]))
        }), 128))
      ]),
      _hoisted_5
    ]),
    _hoisted_6,
    _hoisted_7
  ]))
}
}

})